module.exports = __webpack_public_path__ + "img/minerush.3735210f.png";